var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG",
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#FF5B8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.7351 14.3515L23.1991 8H21.9043L17.1599 13.5149L13.3706 8H9L14.7302 16.3395L9 23H10.2949L15.3051 17.1761L19.3069 23H23.6775L17.7348 14.3515H17.7351ZM15.9616 16.413L15.381 15.5825L10.7614 8.97475H12.7503L16.4783 14.3075L17.0589 15.1379L21.9049 22.0696H19.9161L15.9616 16.4133V16.413Z",
    fill: "#F6A9BD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.0fb34f1ed8a52dd121199a586ca66971.svg";
export { ForwardRef as ReactComponent };